import React, { FC } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';

require('./EventCalendar.less');
require('../../../node_modules/react-big-calendar/lib/css/react-big-calendar.css');

const localizer = momentLocalizer(moment); // or globalizeLocalizer
const EventCalendar: FC<any> = ({ events, handleEventSelect, onSelectEvent, ...otherProps }) => {
	const eventPropGetter = (event) => ({
		className: `calEventCategory--${event.category}`,
	});
	return (
		<div className="eventCalendar__wrapper" style={{}}>
			<Calendar
				localizer={localizer}
				{...otherProps}
				events={events}
				startAccessor="start"
				endAccessor="end"
				step={60}
				eventPropGetter={eventPropGetter}
				showMultiDayTimes
				onSelectEvent={onSelectEvent}
			/>
		</div>
	);
};

export default EventCalendar;
